export const DEFAULT_CONTEXT = {
	['people-menu']: null,
};
